import { render, staticRenderFns } from "./VInput2.vue?vue&type=template&id=12514c00"
import script from "./VInput2.vue?vue&type=script&lang=js"
export * from "./VInput2.vue?vue&type=script&lang=js"
import style0 from "./VInput2.vue?vue&type=style&index=0&id=12514c00&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12514c00')) {
      api.createRecord('12514c00', component.options)
    } else {
      api.reload('12514c00', component.options)
    }
    module.hot.accept("./VInput2.vue?vue&type=template&id=12514c00", function () {
      api.rerender('12514c00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/controls/VInput2.vue"
export default component.exports